var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { mergeData } from './utils';
/**
 * @todo Propagate more options to children.
 */
export var SpaceLayer = function SpaceLayer() {
  return function (options) {
    var children = options.children;
    if (!Array.isArray(children)) return [];
    var _options$x = options.x,
      viewX = _options$x === void 0 ? 0 : _options$x,
      _options$y = options.y,
      viewY = _options$y === void 0 ? 0 : _options$y,
      viewWidth = options.width,
      viewHeight = options.height,
      layerData = options.data;
    return children.map(function (_a) {
      var data = _a.data,
        x = _a.x,
        y = _a.y,
        width = _a.width,
        height = _a.height,
        rest = __rest(_a, ["data", "x", "y", "width", "height"]);
      return Object.assign(Object.assign({}, rest), {
        data: mergeData(data, layerData),
        x: x !== null && x !== void 0 ? x : viewX,
        y: y !== null && y !== void 0 ? y : viewY,
        width: width !== null && width !== void 0 ? width : viewWidth,
        height: height !== null && height !== void 0 ? height : viewHeight
      });
    });
  };
};
SpaceLayer.props = {};